import { render, staticRenderFns } from "./embed-vs-app.vue?vue&type=template&id=41b93055&scoped=true&"
import script from "./embed-vs-app.vue?vue&type=script&lang=js&"
export * from "./embed-vs-app.vue?vue&type=script&lang=js&"
import style0 from "./embed-vs-app.vue?vue&type=style&index=0&id=41b93055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b93055",
  null
  
)

export default component.exports